import { motion, useInView, useScroll, useTransform } from "framer-motion"
import { useRef } from "react"

export default function DashboardIntro() {
  const ref = useRef(null)

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "center center"],
  })

  const rotateX = useTransform(scrollYProgress, [0, 1], [38, 0])
  const y = useTransform(scrollYProgress, [0, 1], [200, 0])
  const opacity = useTransform(scrollYProgress, [0, 0.5], [0, 1])
  const isInView = useInView(ref, { once: true })

  return (
    <section ref={ref} className="relative h-fit overflow-hidden pt-10">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
          className="max-w-3xl md:mb-4 mb-0"
        >
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
            className="text-[36px] md:text-6xl font-semibold text-white mb-6"
          >
            Prove the Buzz
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
            className="text-base md:text-lg text-white"
          >
            Your dashboard tracks what matters: impressions generated, reach by
            geography, downloads, shares, sponsor exposure. No more guessing. No
            more "we think it went well."
          </motion.p>
        </motion.div>

        <div className="relative md:-bottom-12 -bottom-6 mx-auto container">
          <div className="relative z-10 overflow-hidden rounded-3xl md:rounded-[50px] border-[5px] md:border-[6px] border-[#E8E8E8] ">
            <video
              src="https://asts.premagic.com/v/dashboard-intro.mp4"
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
